<template>
  <div class="d-none">
    <b-modal v-model="showModal" centered hide-header hide-footer>
      <div class="modal-header">
        <h4>แลกของสมนาคุณ สาขา {{ test }}</h4>
        <button type="button" aria-label="Close" class="close" @click="hide">
          ×
        </button>
      </div>
      <div class="product-list-panel">
        <div class="bg-sub p-3 title">รายการแลกของรางวัล</div>
        <div v-for="item of data" :key="item.id" class="border p-2">
          <div class="d-flex mb-2">
            <img :src="item.image_url" alt="product" width="50" class="mr-2" />
            <div class="text-gray-2 text-wrap-customs">
              {{ item.product_name }}
            </div>
          </div>
          <div class="row align-items-center">
            <div class="col-6 font-weight-bold">
              {{ item.point_used | numeral("0,0") }} คะแนน
            </div>
            <div class="col-6 text-right">
              <b-button
                class="radius-btn"
                :disabled="item.redeemable == 'N' ? true : false"
                @click="handleSelect(item)"
              >
                เลือก
              </b-button>
            </div>
          </div>
        </div>
      </div>
    </b-modal>
    <ModalConfirmRedeem
      :product="selectedProduct"
      :customer="customer"
      ref="modalConfirmRedeem"
    />
  </div>
</template>

<script>
import ModalConfirmRedeem from "./ModalConfirmRedeem.vue";

export default {
  components: {
    ModalConfirmRedeem,
  },
  props: {
    data: {
      required: false,
      type: Array,
    },
    customer: {
      required: true,
      type: Object,
    },
  },
  data() {
    return {
      showModal: false,
      selectedProduct: {},
    };
  },
  computed: {
    test() {
      return this.$cookies.get("name");
    },
  },
  methods: {
    show() {
      this.showModal = true;
    },
    hide() {
      this.showModal = false;
    },
    handleSelect(item) {
      this.selectedProduct = item;
      this.$refs.modalConfirmRedeem.show();
    },
  },
};
</script>

<style scoped>
.modal-header {
  border-bottom: 0 !important;
  margin: 0px;
  padding: 0px;
  padding-bottom: 0.25rem;
}

::v-deep .modal-body {
  color: var(--primary-color);
}
.btn-outline {
  border-color: var(--primary-color) !important;
  background-color: transparent !important;
  color: var(--primary-color) !important;
}
.text-wrap-customs {
  display: -webkit-box;
  -webkit-line-clamp: 2;
  -webkit-box-orient: vertical;
  overflow: hidden;
  text-overflow: ellipsis;
  line-height: 1.5em;
  height: 3em;
}
.product-list-panel {
  max-height: calc(100vh - 100px);
  overflow-y: auto;
  overflow-x: hidden;
}
.product-list-panel .title {
  position: sticky;
  top: -2px;
  z-index: 1;
}
</style>
